fragment CreateRulesFragment on FormCreateRules {
    contact {
        tags {
            id
            name
        }
        audiences {
            id
            name
        }
    }
    account {
        tags {
            id
            name
        }
        shouldDedupe
    }
    lead {
        stageset {
            id
            name
        }
        tags {
            id
            name
        }
        stagesetFieldRules {
            field {
                id
                label
            }
            answerChoice {
                id
                name
            }
            stageset {
                id
                name
            }
        }
    }
}
